import React, { useState, useRef, useEffect } from 'react';
import TaskPopover from './TaskPopover';

const Task = ({ task, onStatusChange, onEditTask, onDeleteTask }) => {
  console.log(task)
  const [showPopover, setShowPopover] = useState(false);
  const taskRef = useRef(null);

  const handleEyeClick = (e) => {
    e.stopPropagation();
    console.log('Task: Eye button clicked for task:', task);
    setShowPopover(true);
  };

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the task element and the popover
      const isClickOutsideTask = taskRef.current && !taskRef.current.contains(event.target);
      const isClickOutsidePopover = !event.target.closest('.task-popover-sidebar');
      
      // Only close if click is outside both the task and the popover
      if (isClickOutsideTask && isClickOutsidePopover) {
        setShowPopover(false);
      }
    };

    if (showPopover) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopover]);

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    
    // Map status to the backend expected values
    let newStatus;
    if (e.target.checked) {
      newStatus = 4; // Closed status in backend
    } else {
      newStatus = 1; // Open status in backend  
    }
    
    // Call the status change handler with task ID and new status
    onStatusChange(task.id, newStatus);
  };

  // Get task details - simplified since data is now flattened
  const getTaskName = () => {
    return task.name || task.title || 'Untitled Task';
  };

  const getProjectName = () => {
    return task.project_name || task.project?.name || 'Personal';
  };

  const getAssignedUser = () => {
    if (task.members && task.members.length > 0) {
      return task.members[0]; // Show first member
    }
    if (task.assigned_to) {
      return task.assigned_to;
    }
    return null;
  };

  // Check if task is completed - handle both string and numeric status
  const getTaskStatus = () => {
    return task.status;
  };

  // Helper function to convert status integer to string
  const getStatusString = (status) => {
    switch (status) {
      case 1: return 'Open';
      case 2: return 'In Progress';
      case 4: return 'Completed';
      default: return 'Unknown';
    }
  };

  const isCompleted = () => {
    const status = getTaskStatus();
    // Handle both string and numeric status values
    return status === 'Completed' || status === 'Closed' || status === 4;
  };

  const taskCompleted = isCompleted();

  // Helper function to format due date to only show date without time
  const getFormattedDueDate = () => {
    if (!task.due_date) return 'No due date';
    
    try {
      // If due_date is already in YYYY-MM-DD format, return as is
      if (/^\d{4}-\d{2}-\d{2}$/.test(task.due_date)) {
        return task.due_date;
      }
      
      // Parse the date and format to YYYY-MM-DD
      const date = new Date(task.due_date);
      return date.toISOString().split('T')[0];
    } catch (error) {
      console.error('Error formatting due date:', error);
      return task.due_date; // Fallback to original
    }
  };
const colorMapping = {
  blue: 1,
  green: 2,
  red: 3,
  purple: 4,
  orange: 5
};

// Reverse mapping: { 1: "blue", ... }
const reverseColorMapping = Object.fromEntries(
  Object.entries(colorMapping).map(([key, value]) => [value, key])
);

// Gradient background colors
const gradientMapping = {
  blue: 'linear-gradient(135deg, #3b82f6, #2563eb)',
  green: 'linear-gradient(135deg, #10b981, #059669)',
  red: 'linear-gradient(135deg, #ef4444, #dc2626)',
  purple: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
  orange: 'linear-gradient(135deg, #f59e0b, #d97706)'
};

// Darker text color for titles
const titleColorMapping = {
  blue: '#ffffff29',
  green: '#ffffff29',
  red: '#ffffff29',
  purple: '#ffffff29',
  orange: '#ffffff29'
};

const borderColorMapping = {
  blue: '#2563eb',
  green: '#059669',
  red: '#dc2626',
  purple: '#7c3aed',
  orange: '#d97706'
};

const colorName = reverseColorMapping[task.color] || 'blue';
const borderName = reverseColorMapping[task.color] || 'blue';

const backgroundStyle = {
  background: gradientMapping[colorName],
  borderLeft: '4px solid',
  borderLeftColor: borderColorMapping[borderName]
};

const titleStyle = {
  background: titleColorMapping[colorName]
};

  return (
    <div className="task-wrapper">
      <div
        ref={taskRef}
        className={`task ${taskCompleted ? 'completed' : ''}`}
        style={backgroundStyle}
      >
        <div className="task-header">
          <div className="task-check-title">
            <input
              type="checkbox"
              className="task-checkbox"
              checked={taskCompleted}
              onChange={handleCheckboxClick}
            />
            <h3 className={`task-title ${taskCompleted ? 'strikethrough' : ''}`}>
              {getTaskName()}
            </h3>
          </div>
          <div className="task-actions">
            <button
              className="task-view-btn"
              onClick={handleEyeClick}
              title="View task details"
            >
              <i className="fas fa-eye"></i>
            </button>
          </div>
        </div>
        
        <div className="task-meta-row" style={titleStyle}>
          <div className="task-meta-item">
            <span className="task-projects">{getProjectName()}</span>
            {/* <i className="fas fa-project-diagram"></i> */}
            {/* <span className="task-project">{getProjectName()}</span> */}
            {/* <button className="meta-btn" title="View project"> */}
              {/* <i className="fas fa-external-link-alt"></i> */}
            {/* </button> */}
          </div>
          
          {getAssignedUser() && (
            <div className="task-meta-item">
              <span className="task-owners">{getAssignedUser()}</span>
              {/* <i className="fas fa-user"></i>
              <span className="task-owner">{getAssignedUser()}</span>
              <button className="meta-btn" title="View user profile">
                <i className="fas fa-external-link-alt"></i>
              </button> */}
            </div>
          )}
          
          <div className="task-meta-item">
            <i className="fas fa-calendar-alt"></i>
            <span className="task-due-dates">{getFormattedDueDate()}</span>
            {/* <button className="meta-btn" title="Change due date">
              <i className="fas fa-edit"></i>
            </button> */}
          </div>
          
          <div className="task-meta-item">
            <i className="fas fa-flag"></i>
            <span className="task-statuses">{getStatusString(getTaskStatus())}</span>
            {/* <button className="meta-btn" title="Change status">
              <i className="fas fa-edit"></i>
            </button> */}
          </div>
        </div>
      </div>
      
      <TaskPopover
        task={task}
        isVisible={showPopover}
        onClose={() => setShowPopover(false)}
        onEdit={onEditTask}
        onDelete={onDeleteTask}
      />
    </div>
  );
};

export default Task; 